import { render } from "./meet-our-team.vue?vue&type=template&id=674cd416&scoped=true"
import script from "./meet-our-team.vue?vue&type=script&lang=js"
export * from "./meet-our-team.vue?vue&type=script&lang=js"

import "./meet-our-team.vue?vue&type=style&index=0&id=674cd416&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674cd416"]])

export default __exports__